import React from 'react';
import styled from 'styled-components';

// common header title styling with status
export const StyledHeaderTitle = styled.div`
  display: flex;
  flex-direction: column;
  .status-container {
    display: flex;
    margin-top: 5px;
    .status-label {
      margin-right: 8px;
    }
  }
`;

export interface HeaderTitleProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  className?: string;
}

const HeaderTitle: React.FC<HeaderTitleProps> = (props: HeaderTitleProps) => {
  const { children, className, ...divProps } = props;
  return (
    <StyledHeaderTitle {...divProps} className={className}>
      {children}
    </StyledHeaderTitle>
  );
};

export default HeaderTitle;
